import { ARENA_RANK_SYMBOL_TO_STR } from "@/game-lol/constants/arena-queue-constants.mjs";
import { RANK_SYMBOL_TO_STR } from "@/game-lol/constants/constants.mjs";

/**
 * Cast strings to symbols, used for data model transformation.
 */

// Non-arena ranks
const nonArenaMap = {};
for (const [symbol, rank] of RANK_SYMBOL_TO_STR) {
  for (const k of ["key", "gql"]) {
    const v = rank[k].toLowerCase();
    nonArenaMap[v] = symbol;
  }
}

export function RankSymbol(value: string | symbol): symbol {
  if (typeof value === "symbol") return value;
  return nonArenaMap[`${value}`.toLowerCase()];
}

// Arena ranks
const arenaMap = {};
for (const [symbol, rank] of ARENA_RANK_SYMBOL_TO_STR) {
  for (const k of ["key", "gql"]) {
    const v = rank[k].toLowerCase();
    arenaMap[v] = symbol;
  }
}

export function RankSymbolArena(value: string): symbol {
  if (typeof value === "symbol") return value;
  return arenaMap[`${value}`.toLowerCase()];
}
